export default __webpack_public_path__ + "static/media/gallery_06.97e212e2.jpg";